import React, { useEffect, useState } from "react";
import axios from "axios";
import { Typography } from "@mui/material";
import ImgInstagram from "../assets/images/ImgInsta.svg";
import ImgLinkedIn from "../assets/images/ImgLinkedin.svg";
import ImgTwitter from "../assets/images/Imgtweet.svg";
import Aos from "aos";
import "aos/dist/aos.css";
import { HomeButtons } from "./landingPage/HomeButtons";

export const Footer = ({ color }) => {
  const [footerData, setFooterData] = useState(null);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
      offset: 500,
    });

    const fetchFooterData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/footer`
        );
        setFooterData(response.data);
      } catch (error) {
        console.error("Error fetching footer data:", error);
      }
    };

    fetchFooterData();
  }, []);

  return (
    <div
      className="w-full py-8 px-4 md:px-8 lg:px-16"
      style={{ background: color }}
    >
      <div className="max-w-7xl mx-auto">
        {footerData?.sections.map((section, index) => (
          <div
            key={index}
            className="flex flex-col lg:flex-row items-center justify-between"
          >
            {/* Left section - Content */}
            <div className="w-full lg:w-1/2 mb-8 lg:mb-0 text-center lg:text-left">
              <Typography
                variant="h3"
                style={{
                  fontWeight: "bolder",
                  fontSize: "2.5rem",
                  fontFamily: "Montserrat",
                  marginBottom: "1rem",
                }}
                className="text-white text-3xl md:text-4xl lg:text-5xl"
              >
                {section.section_heading}
              </Typography>
              <Typography
                style={{ fontFamily: "Montserrat" }}
                className="text-white text-base md:text-lg"
              >
                {section.section_description}
              </Typography>
              {/* Social icons */}
              <div className="flex justify-center lg:justify-start mt-8 space-x-6">
                {section.details[0]?.buttons.slice(0, 3).map((button, idx) => (
                  <a
                    key={idx}
                    href={button.action}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-75 transition-opacity"
                  >
                    <img
                      src={
                        button.label === "Instagram"
                          ? ImgInstagram
                          : button.label === "LinkedIn"
                          ? ImgLinkedIn
                          : button.label === "x"
                          ? ImgTwitter
                          : ""
                      }
                      className="h-8 w-8 md:h-10 md:w-10"
                      alt={button.label}
                    />
                  </a>
                ))}
              </div>
            </div>
            {/* Right section - Buttons */}
            <div className="w-full lg:w-auto flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 lg:space-x-8 invisible sm:visible">
              {section.details[0]?.buttons.slice(3).map((button, idx) => (
                <div
                  key={idx}
                  className={`mr-4 flex justify-center items-center pr-4 cursor-pointer footer-img-style text-sm ${
                    idx === 0 ? "mail" : "utube"
                  }`}
                >
                  <div className="text-white text-center  sm:text-xs md:text-sm lg:text-sm">
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={button.action}
                      className="hover:underline"
                    >
                      {button.label}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
        {/* Mobile-only buttons */}
        <div className="mt-8 lg:hidden flex justify-center">
          <HomeButtons
            footerButtons={
              footerData?.sections[0]?.details[0]?.buttons.slice(3) || []
            }
          />
        </div>
      </div>
    </div>
  );
};
